import { Inject, Injectable } from '@angular/core';
import { EnvironmentRef } from 'projects/tmhna-portal/src/environments/interfaces/environment.interface';
import { expEnvironmentRef } from '../../injection-tokens/environment.injection-token';

@Injectable({
	providedIn: 'root'
})
export class RaymondAnalyticsService 
{

	constructor(@Inject(expEnvironmentRef) private readonly environmentRef: EnvironmentRef) { }

	initGoogleAnalytics(): void 
	{
		const gaUrl = this.environmentRef?.raymondAnalytics?.scripts?.launch?.src;
		const gaId = this.environmentRef?.raymondAnalytics?.scripts?.launch?.gtag;
		const clarityId = this.environmentRef?.msClarityId;


		if (gaUrl && gaId) 
		{
			const scriptTag = document.createElement('script');
			scriptTag.src = gaUrl;
			scriptTag.async = true;
			document.head.appendChild(scriptTag);

			const inlineScript = document.createElement('script');
			inlineScript.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){ dataLayer.push(arguments); }
      gtag('js', new Date());
      gtag('config', '${gaId}');
    `;
			document.head.appendChild(inlineScript);
		}


		if (clarityId) 
		{
			const clarityScript = document.createElement('script');
			clarityScript.type = 'text/javascript';
			clarityScript.text = `
      (function(c,l,a,r,i,t,y){
          c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
          y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
      })(window, document, "clarity", "script", "${clarityId}");
    `;
			document.head.appendChild(clarityScript);
		}
	}


}
